import { render, staticRenderFns } from "./integrations_view.vue?vue&type=template&id=7970b89f&scoped=true&"
import script from "./integrations_view.vue?vue&type=script&lang=js&"
export * from "./integrations_view.vue?vue&type=script&lang=js&"
import style0 from "./integrations_view.vue?vue&type=style&index=0&id=7970b89f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970b89f",
  null
  
)

export default component.exports